import { useDispatch, useSelector, TypedUseSelectorHook } from 'react-redux';
import type { RootState, AppDispatch } from './configureStore';

// Pre-typed versions of the react-redux hooks. As components migrate to TS/TSX,
// use these instead of the plain hooks to get a typed `state` (autocomplete +
// checking on store.customer.customerName etc.) and a thunk-aware dispatch.
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
